import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/promise';
import 'raf/polyfill';
import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import MainRoute from './components/MainRoute';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

class App extends React.Component {
    render() {
        const store = configureStore();
        return (
            <Provider store={store}>
                <Router>
                    <Route component={MainRoute} />
                </Router>
            </Provider>
        );
    }
}
render(<App />, document.getElementById('merchZoneApp'));